var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-2"},[_c('b-card-text',[_c('b-row',[_c('p',{staticClass:"info"},[_vm._v("App version: v"+_vm._s(_vm.appVersion))])])],1),_c('b-row',{staticStyle:{"text-align":"center"}},[_c('b-button',{attrs:{"id":"btnBack","href":"/","variant":"outline-primary"}},[_vm._v("Go Back")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }